import Vue from "vue";
import axios from "axios";
import App from "./App";
import router from "./router";
import store from "./store";
import Buefy from "buefy";
import "buefy/dist/buefy.css";
import "./filters";
import i18n from "./i18n";
import fontAwesome from "./setup/fontAwesome";
import RegisterCommonComponents from "./components/VsComponents";
import Amplify, * as AmplifyModules from "aws-amplify";
import { AmplifyPlugin } from "aws-amplify-vue";

Amplify.configure({
  Auth: {
    userPoolId: process.env.VUE_APP_AMPLIFY_IDENTITY_POOL_ID,
    userPoolWebClientId: process.env.VUE_APP_AMPLIFY_APP_CLIENT_ID,
    region: process.env.VUE_APP_AMPLIFY_REGION,
  },
  // This is just for memo. I tried this way but there was no benefit, because I had to set token everytime.
  // API: {
  //   endpoints: [
  //     {
  //       name: 'ANALYTICS_API',
  //       endpoint: 'https://8hgxh9qtvl.execute-api.ap-northeast-1.amazonaws.com/stg',
  //       region: process.env.VUE_APP_AMPLIFY_REGION
  //     }
  //   ]
  // }
});
Vue.use(AmplifyPlugin, AmplifyModules);

Vue.use(i18n, { store });

Vue.config.productionTip = false;
Vue.use(Buefy, {
  defaultIconPack: "fas",
});

axios.defaults.baseURL = process.env.VUE_APP_LAMBDA_API;
fontAwesome();
RegisterCommonComponents(Vue);

new Vue({
  router,
  store,
  i18n,
  render: (h) => h(App),
}).$mount("#app");
